<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="mb-5 mx-3">
        <v-row align="center">
          <v-col class="white">
            <div class="align-center d-flex">
              <v-btn small depressed class="mr-2 text-uppercase primary white--text">
                {{ cartProduct.product|appTranslate('name') }}
              </v-btn>
              <div class="d-none d-sm-block">
                <CartProductTitle :cartProduct="cartProduct"/>
              </div>
              <v-spacer></v-spacer>
              <PriceDisplay class="ml-auto" :cart-product="cartProduct" :strong="true" :number-of-days="numberOfDays"/>
            </div>
          </v-col>
        </v-row>
        <v-row class="white">
          <v-col cols="12" sm="4" class="py-0">
            <v-text-field
                class="cart-product-owner"
                v-model="cartProduct.owner"
                outlined
                dense
                :label="'skiman_name'|globalTranslate"
                :rules="ownerRules"
                hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="8">
            <div class="d-sm-flex align-center py-4 py-sm-0"
                 v-if="cartProduct.product.productEquipments.length">
              <div :class="{'ml-sm-10': k > 0, 'mt-5': k > 0, 'mt-sm-0': k > 0}" class="d-flex align-center"
                   v-for="(equipment,k) of cartProduct.product.productEquipments" :key="k">
                <v-img class="mr-3"
                       :class="{'disabled-box':!cartProduct.equipments[`${k}`]}"
                       :src="`${apiUrl}/uploads/equipments-images/${equipment.image.filename}`"
                       max-width="50"/>
                <v-checkbox
                    v-model="cartProduct.equipments[`${k}`]"
                    :input-value="equipment"
                    :label="equipment|appTranslate('name')"
                    dense
                    class="my-0 py-0 product-equipment"
                    @click.native="update"
                ></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="white">
          <v-col cols="4" class="py-0">
            <v-select
                v-model="cartProduct.size"
                :items="data.sizes"
                :placeholder="'placeholder_size'|globalTranslate"
                item-text="name"
                dense
                :return-object="true"
                required>
            </v-select>
          </v-col>
          <v-col cols="4" class="py-0" v-if="cartProduct.product.productEquipments.length">
            <v-select
                v-model="cartProduct.weight"
                :items="data.weights"
                :placeholder="'placeholder_weight'|globalTranslate"
                item-text="name"
                dense
                :return-object="true"
                required>
            </v-select>
          </v-col>
          <v-col cols="4" class="py-0" v-if="cartProduct.product.productEquipments.length">
            <v-select
                v-model="cartProduct.shoeSize"
                :items="data.shoeSizes"
                :placeholder="'placeholder_shoe_size'|globalTranslate"
                item-text="name"
                dense
                :return-object="true"
                required>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-form>
  </div>
</template>

<script>
import CartProductTitle from "@/components/CartProductTitle";
import PriceDisplay from "@/components/PriceDisplay";

export default {
  name: "CartProductForm",
  components: {
    CartProductTitle,
    PriceDisplay
  },
  data() {
    return {
      ownerRules: [
        value => !!value || "Ce champ est requis",
        value => (value && value.length >= 3) || "La longueur minimale est de 3 caractères",
      ],
      valid: true
    }
  },
  methods: {
    update() {
      this.$emit("update", this.cartProduct);
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    cartProduct: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    numberOfDays: {
      type: Number,
      required: true
    },
  }
}
</script>

<style scoped>

</style>
